"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const svgson_1 = require("svgson");
const element_to_path_1 = __importDefault(require("element-to-path"));
// took the code directly from https://github.com/elrumordelaluz/path-that-svg,
// since it didn't have a Sync implementation
const elemToPath = (node) => {
    const o = Object.assign({}, node);
    if (/(rect|circle|ellipse|polygon|polyline|line|path)/.test(o.name)) {
        o.attributes = Object.assign({}, o.attributes, {
            d: element_to_path_1.default(o),
        });
        for (const attr in o.attributes) {
            // Remove geometry properties not used
            if (/^(x|y|x1|y1|x2|y2|points|width|height|cx|cy|rx|ry|r)$/.test(attr)) {
                delete o.attributes[attr];
            }
        }
        o.name = 'path';
    }
    else if (o.children && Array.isArray(o.children)) {
        o.children = o.children.map(elemToPath);
    }
    return o;
};
function svgToPath(svg) {
    const parsed = svgson_1.parseSync(svg);
    const convertedToPath = elemToPath(parsed);
    return svgson_1.stringify(convertedToPath);
}
exports.default = svgToPath;
//# sourceMappingURL=svgToPath.js.map